import { FormApi, SubmissionErrors } from 'final-form';
import React from 'react';
import { Field, Form } from 'react-final-form';
import Select from 'react-select';
import {
  Button,
  Col,
  Form as FormComponent,
  FormGroup,
  Input,
  Label,
  Spinner,
} from 'reactstrap';
function validateEmail(email: string) {
  var re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
  return re.test(email);
}
export interface PractitionerFormValues {
  email: string;
  firstName: string;
  lastName: string;
  gender: { value: string; label: string };
  role: { value: string; label: string };
}

const RenderText = ({
  name,
  label,
  placeholder,
  disabled,
}: {
  name: string;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  validate?: () => boolean;
}) => (
  <FormGroup row>
    <Label for={name} sm={2}>
      {label}
    </Label>
    <Col sm={10}>
      <Field<string>
        name={name}
        disabled={disabled}
        placeholder={placeholder}
        validate={(value: string | undefined) =>
          !value || value.length === 0 ? 'This field is required' : undefined
        }>
        {({ input, meta, ...rest }) => (
          <div>
            <Input {...input} {...rest} type="text" invalid={!!meta.error} />
            <span
              className={
                meta.error ? 'text-danger visible' : 'text-danger invisible'
              }>
              {meta.error ? meta.error : 'All good'}
            </span>
          </div>
        )}
      </Field>
    </Col>
  </FormGroup>
);

const RenderEmail = ({
  name,
  label,
  placeholder,
  disabled,
}: {
  name: string;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  validate?: () => boolean;
}) => (
  <FormGroup row>
    <Label for={name} sm={2}>
      {label}
    </Label>
    <Col sm={10}>
      <Field<string>
        name={name}
        disabled={disabled}
        placeholder={placeholder}
        validate={(value: string | undefined) =>
          !value
            ? 'This field is required'
            : !validateEmail(value)
            ? 'Please enter a valid email'
            : undefined
        }>
        {({ input, meta, ...rest }) => (
          <div>
            <Input {...input} {...rest} type="email" invalid={!!meta.error} />
            <span
              className={
                meta.error ? 'text-danger visible' : 'text-danger invisible'
              }>
              {meta.error ? meta.error : 'All good'}
            </span>
          </div>
        )}
      </Field>
    </Col>
  </FormGroup>
);

const RenderSelect = ({
  name,
  label,
  placeholder,
  disabled,
  options,
}: {
  name: string;
  label: string;
  options: { value: string; label: string }[];
  placeholder?: string;
  disabled?: boolean;
}) => (
  <FormGroup row>
    <Label for={name} sm={2}>
      {label}
    </Label>
    <Col sm={10}>
      <Field<{ value: string; label: string }>
        name={name}
        disabled={disabled}
        placeholder={placeholder}
        validate={(value: { value: string } | undefined) =>
          !value ? 'This field is required' : undefined
        }>
        {({ input, meta, ...rest }) => (
          <div>
            <Select
              {...input}
              {...rest}
              type="text"
              invalid={!!meta.error}
              options={options}
              isClearable
            />
            {
              <span
                className={
                  meta.error ? 'text-danger visible' : 'text-danger invisible'
                }>
                {meta.error ? meta.error : 'All good'}
              </span>
            }
          </div>
        )}
      </Field>
    </Col>
  </FormGroup>
);

const PractitionerForm = (props: {
  initialValues?: PractitionerFormValues;
  onSubmit: (
    values: PractitionerFormValues,
    form: FormApi<PractitionerFormValues, PractitionerFormValues>,
    callback?: (errors?: SubmissionErrors) => void,
  ) =>
    | SubmissionErrors
    | Promise<SubmissionErrors | undefined>
    | undefined
    | void;
}) => {
  return (
    <Form onSubmit={props.onSubmit} initialValues={props.initialValues}>
      {({ handleSubmit, submitting, hasValidationErrors }) => (
        <FormComponent onSubmit={handleSubmit}>
          <RenderEmail name="email" placeholder="Email" label="Email" />
          <RenderText
            name="firstName"
            placeholder="First Name"
            label="First Name"
          />
          <RenderText
            name="lastName"
            placeholder="Last Name"
            label="Last Name"
          />
          <RenderSelect
            name="gender"
            placeholder="Male / Female / Other"
            label="Gender"
            options={[
              { value: 'male', label: 'Male' },
              { value: 'female', label: 'Female' },
              { value: 'other', label: 'Other' },
            ]}
          />
          <RenderSelect
            name="role"
            placeholder="Nurse / Researcher"
            label="Role"
            options={[
              { value: 'nurse', label: 'Nurse' },
              { value: 'researcher', label: 'Researcher' },
            ]}
          />
          {/* <RenderText name="organization" label="Organization" disabled /> */}
          <Col className="d-flex justify-content-end">
            <Button color="success" disabled={hasValidationErrors}>
              {submitting ? <Spinner size="sm" /> : 'Submit'}
            </Button>
          </Col>
        </FormComponent>
      )}
    </Form>
  );
};

export default PractitionerForm;
